import React from "react";
import {
  Box,
  IconButton,
  TablePagination,
  useMediaQuery,
  Stack,
  Pagination,
} from "@mui/material";
import {
  KeyboardArrowRight,
  KeyboardArrowLeft,
  FirstPage,
  LastPage,
} from "@mui/icons-material";

const CustomPagination = ({
  dataCount,
  rowsPerPage,
  page,
  setPage,
  setRowsPerPage,
  disableNext,
  total,
}) => {
  const isMobileScreen = useMediaQuery("(max-width:750px)"); // Change the width as per your requirement

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const CustomActions = (props) => {
    const { count, page, rowsPerPage, onPageChange } = props;
    const totalPages = Math.ceil(count / rowsPerPage);

    return (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onPageChange(null, 0)} disabled={page === 0}>
          <FirstPage />
        </IconButton>
        <IconButton
          onClick={() => onPageChange(null, page - 1)}
          disabled={page === 0}
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={() => onPageChange(null, page + 1)}
          disabled={page >= totalPages - 1 || disableNext}
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={() => onPageChange(null, totalPages - 1)}
          disabled={page >= totalPages - 1 || disableNext}
        >
          <LastPage />
        </IconButton>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "var(--bg-paper)",
        padding: "2px",
        borderTop: "1px solid var(--border-color)",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {isMobileScreen ? (
        <Stack
          spacing={2}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "var(--bg-paper)",
            padding: "8px",
            borderTop: "1px solid var(--border-color)",
            alignItems: "end",
          }}
        >
          <Pagination
            color="primary"
            count={Math.ceil(dataCount / rowsPerPage)}
            page={page + 1}
            shape="rounded"
            onChange={(event, newPage) => handleChangePage(event, newPage - 1)}
          />
        </Stack>
      ) : (
        <TablePagination
          component="div"
          count={dataCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[15, 25, 45, 75, 100]}
          ActionsComponent={CustomActions}
          // nextIconButton={
          //   <IconButton>
          //     <KeyboardArrowRight />
          //   </IconButton>
          // }
          // backiconbutton={
          //   <IconButton>
          //     <KeyboardArrowLeft />
          //   </IconButton>
          // }
          slotProps={{
            actions: total
              ? {}
              : {
                  nextButton: {
                    disabled: disableNext,
                  },
                },
          }}
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "var(--bg-paper)",
            padding: "2px",
            borderTop: "1px solid var(--border-color)",
          }}
        />
      )}
    </Box>
  );
};

export default CustomPagination;
